import { withInstall } from '../../utils'

import _Image from './src/image.vue'

export const SdImage = withInstall(_Image)
export default SdImage

export * from './src/image'
